/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * What kind of surface content is placed on. Peer of EngagementType.
 * @export
 */
export const SurfaceType = {
    HUB: 'HUB',
    DROP: 'DROP',
    CHALLENGE: 'CHALLENGE',
    COMPETITION: 'COMPETITION',
    PARTNER_ORIGIN: 'PARTNER_ORIGIN',
    OBS_OVERLAY: 'OBS_OVERLAY',
    IN_GAME_OVERLAY: 'IN_GAME_OVERLAY'
} as const;
export type SurfaceType = typeof SurfaceType[keyof typeof SurfaceType];


export function instanceOfSurfaceType(value: any): boolean {
    for (const key in SurfaceType) {
        if (Object.prototype.hasOwnProperty.call(SurfaceType, key)) {
            if (SurfaceType[key as keyof typeof SurfaceType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SurfaceTypeFromJSON(json: any): SurfaceType {
    return SurfaceTypeFromJSONTyped(json, false);
}

export function SurfaceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceType {
    return json as SurfaceType;
}

export function SurfaceTypeToJSON(value?: SurfaceType | null): any {
    return value as any;
}

export function SurfaceTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SurfaceType {
    return value as SurfaceType;
}

